// Add eventlisteners for filter facets to open and close
// ---------------------------------
document.addEventListener('addFacetEvents', (customEvent) => {
  // MENU-692: Added
  // Eventlistener to close other facets when a new facet has been clicked
  const details = document.querySelectorAll('.custom-horizontal-filter__desktop details:not(.filters__disclosure)');

  details.forEach((detail) => {
    detail.querySelector('summary').addEventListener('click', (e) => {
      localStorage.setItem('lastFilterFacet', e.target.closest('details').id);
      details.forEach((detail2) => {
        if (detail2 != e.target.closest('details')) {
          detail2.open = false;
        }
      });
    });
  });

  // Remove default open animation
  // --------------------------------------
  if (customEvent.detail && customEvent.detail.filterIsOpen) {
    // Add animation blocker, when facet is clicked
    document.querySelectorAll('.filters__disclosure .facets__display').forEach((elem) => {
      elem.classList.add('no-animate');
    });
  }
});
document.dispatchEvent(new CustomEvent('addFacetEvents')); // MENU-692: Added

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    this.setInitialFilterStickyPosition(); // MENU-692: Added
    this.setMobileFilterPositions(); // MENU-692: Added
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        this.renderSection(html, event);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    this.renderSection(html, event);
    if (document.getElementById(`${localStorage.getItem('lastFilterFacet')}`)) {
      document.getElementById(`${localStorage.getItem('lastFilterFacet')}`).open = true; // MENU-692: Added
    }
  }

  static renderSection(html, event) {
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    FacetFiltersForm.renderFiltersChosenCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderFiltersChosenCount() {
    const checkboxes_checked = document.querySelectorAll('facet-remove:not(.active-facets__button-wrapper)');
    const counterHolder = document.getElementById('filters-chosen-counter');
    if (counterHolder) {
      if (checkboxes_checked && checkboxes_checked.length > 0) {
        counterHolder.innerHTML = ` (${checkboxes_checked.length})`;
      } else {
        counterHolder.innerHTML = '';
      }
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    /* MENU-692: Added */
    if (document.getElementById(`${localStorage.getItem('lastFilterFacet')}`)) {
      document.getElementById(`${localStorage.getItem('lastFilterFacet')}`).setAttribute('open', true); // MENU-692: Added
    }

    document.dispatchEvent(new CustomEvent('addFacetEvents', { detail: { filterIsOpen: 'true' } }));

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    if (event.target !== document.querySelector('#SortBy')) {
      if (event.target.closest('details')) {
        localStorage.setItem('lastFilterFacet', event.target.closest('details').id); // MENU-692: Added
      }
    }

    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      sortFilterForms.forEach((form) => {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }

  setInitialFilterStickyPosition() {
    // MENU-692: Added
    // The filters should be placed underneath the header,
    // therefore if the header is set to sticky
    // the header height is calculated and used as the top position for the filter
    const stickyHeader = document.querySelector('sticky-header');
    const filterElement = this.closest('.facets-wrapper');

    if (stickyHeader) {
      const stickyType = stickyHeader.getAttribute('data-sticky-type');
      if (stickyType == 'always' || stickyType == 'reduce-logo-size') {
        filterElement.style.top = getComputedStyle(document.body).getPropertyValue('--header-height');
      } else {
        filterElement.style.top = '0';
      }
    } else {
      filterElement.style.top = '0';
    }
  }

  setMobileFilterPositions() {
    // MENU-692: Added
    // When the filter is open on mobile it should fill the entire screen
    const mobileFacets_disclosure = document.querySelector('.mobile-facets__disclosure');
    if (mobileFacets_disclosure) {
      mobileFacets_disclosure.addEventListener('toggle', (event) => {
        const filterIsOpen = event.target.hasAttribute('open');
        const stickyHeader = document.querySelector('sticky-header[data-sticky-type="on-scroll-up"]');

        if (filterIsOpen) {
          mobileFacets_disclosure.closest('form').classList.add('open-mobile');
        } else {
          mobileFacets_disclosure.closest('form').classList.remove('open-mobile');
        }

        // Get distance from element to top of screen
        const facetsContainer = event.target.closest('.facets-container');
        const relativePosition = this.getOffset(facetsContainer).top;
        const distanceToTopOfScreen = relativePosition - window.scrollY;
        const scrollPosition = window.scrollY;

        // If at the top of the page and theres a distance from filter to top of screen and the filter is open
        // Then scroll down to top of filter
        if (distanceToTopOfScreen > scrollPosition && filterIsOpen) {
          window.scrollBy({
            top: this.getOffset(facetsContainer).top,
            left: 0,
            behavior: 'smooth',
          });
        }

        // Hide sticky header when filter is open
        if (filterIsOpen & stickyHeader) {
          stickyHeader.classList.add('hidden');
        } else if (!filterIsOpen & stickyHeader) {
          stickyHeader.classList.remove('hidden');
        }
      });
    }
  }

  getOffset(el) {
    // MENU-692: Added
    // Get the element position relative to the whole document page
    const rect = el.getBoundingClientRect();
    return {
      top: rect.top + window.scrollY,
    };
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.facetId = this.getAttribute('data-value');
    this.removeAll = this.hasAttribute('data-remove-all');
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    if (this.facetId) {
      const facetInput = form.querySelector(`input[value="${this.facetId}"]`);
      facetInput.checked = false;
    }
    if (this.removeAll) {
      const facetInputs = form.querySelectorAll('.facet-checkbox-new input[type="checkbox"]:checked');
      for (let i = 0; i < facetInputs.length; i++) {
        const element = facetInputs[i];
        element.checked = false;
      }
    }
  }
}

//NEEDED "_" TO AVOID THIS SCRIPT
customElements.define('facet-remove_', FacetRemove);

document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const selectOneButton = document.getElementById('select-one');
  const selectTwoButton = document.getElementById('select-two');
  const selectThreeButton = document.getElementById('select-three');
  const selectFourButton = document.getElementById('select-four');

  function replaceXlGridColumnClasses(replacementNumber) {
    const allElements = document.querySelectorAll('*');
    allElements.forEach((element) => {
      if (element.classList && element.classList.length > 0) {
        const classArray = Array.from(element.classList);
        classArray.forEach((className) => {
          const regex = /xl:tw-grid-cols-([1-8])-1fr/;
          const match = className.match(regex);
          if (match) {
            const currentNumber = match[1];
            if (currentNumber !== replacementNumber.toString()) {
              element.classList.remove(className);
              element.classList.add(`xl:tw-grid-cols-${replacementNumber}-1fr`);
            }
          }
        });
      }
    });
  }



  function replaceLgGridColumnClasses(replacementNumber) {
    const allElements = document.querySelectorAll('*');
    allElements.forEach((element) => {
      if (element.classList && element.classList.length > 0) {
        const classArray = Array.from(element.classList);
        classArray.forEach((className) => {
          const regex = /lg:tw-grid-cols-([1-8])-1fr/;
          const match = className.match(regex);
          if (match) {
            const currentNumber = match[1];
            if (currentNumber !== replacementNumber.toString()) {
              element.classList.remove(className);
              element.classList.add(`lg:tw-grid-cols-${replacementNumber}-1fr`);
            }
          }
        });
      }
    });
  }

  function replaceMaxMdGridColumnClasses(replacementNumber) {
    const allElements = document.querySelectorAll('*');
    allElements.forEach((element) => {
      if (element.classList && element.classList.length > 0) {
        const classArray = Array.from(element.classList);
        classArray.forEach((className) => {
          const regex = /max-md:tw-grid-cols-([1-2])-1fr/;
          const match = className.match(regex);
          if (match) {
            const currentNumber = match[1];
            if (currentNumber !== replacementNumber.toString()) {
              element.classList.remove(className);
              element.classList.add(`max-md:tw-grid-cols-${replacementNumber}-1fr`);
            }
          }
        });
      }
    });
  }
  function toggleMobileActiveClass(activeButton) {
    if (selectOneButton) {
      selectOneButton.classList.remove('selection-active');
      selectOneButton.setAttribute('aria-pressed', 'false');
    }
    if (selectTwoButton) {
      selectTwoButton.classList.remove('selection-active');
      selectTwoButton.setAttribute('aria-pressed', 'false');
    }
    activeButton.classList.add('selection-active');
    activeButton.setAttribute('aria-pressed', 'true');
  }
  function toggleDesktopActiveClass(activeButton) {
    if (selectThreeButton) {
      selectThreeButton.classList.remove('selection-active');
      selectThreeButton.setAttribute('aria-pressed', 'false');
    }
    if (selectFourButton) {
      selectFourButton.classList.remove('selection-active');
      selectFourButton.setAttribute('aria-pressed', 'false');
    }
    activeButton.classList.add('selection-active');
    activeButton.setAttribute('aria-pressed', 'true');
  }
  function setGridVars({ units, standard, dbl, colsDesktop, colsMobile }) {
    document.querySelectorAll('#product-grid').forEach(el => {
      el.style.setProperty('--grid-units', units);
      el.style.setProperty('--span-standard', `span ${standard}`);
      el.style.setProperty('--span-double', `span ${dbl}`);
      if (colsDesktop != null) el.style.setProperty('--cols-desktop', colsDesktop);
      if (colsMobile != null) el.style.setProperty('--cols-mobile', colsMobile);
    });
    // Apply to all .product-grid elements inside the search page so the
    // article/blog grid follows the view-by selection alongside the product grid.
    if (colsDesktop != null || colsMobile != null) {
      document.querySelectorAll('.template-search .product-grid').forEach(el => {
        if (colsDesktop != null) {
          el.style.setProperty('--cols-desktop', colsDesktop);
          // Article grid CSS reads --grid-units directly (visible count semantics).
          if (el.matches('[data-articles-grid]')) {
            el.style.setProperty('--grid-units', colsDesktop);
          }
        }
        if (colsMobile != null) el.style.setProperty('--cols-mobile', colsMobile);
      });
    }
  }
  if (urlParams.has('column-grid')) {
    const columnGridValue = urlParams.get('column-grid');

    if (columnGridValue === '1') {
      setGridVars({ units: 1, standard: 1, dbl: 1, colsMobile: 1 });
    }
    if (columnGridValue === '2') {
      setGridVars({ units: 2, standard: 1, dbl: 2, colsMobile: 2 });
      replaceMaxMdGridColumnClasses(2);
      toggleMobileActiveClass(selectTwoButton);
    }
    if (columnGridValue === '3') {
      setGridVars({ units: 6, standard: 2, dbl: 3, colsDesktop: 3 });
      replaceXlGridColumnClasses(6);
      replaceLgGridColumnClasses(6);
    }
    if (columnGridValue === '4') {
      setGridVars({ units: 8, standard: 2, dbl: 4, colsDesktop: 4 });
      replaceXlGridColumnClasses(8);
      replaceLgGridColumnClasses(8);
    }
  }

  function addEnterKeySupport(button) {
    if (button) {
      button.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          button.click();
        }
      });
    }
  }
  addEnterKeySupport(selectOneButton);
  addEnterKeySupport(selectTwoButton);
  addEnterKeySupport(selectThreeButton);
  addEnterKeySupport(selectFourButton);

  function updatePaginationLinks(columnGridValue) {
    document.querySelectorAll('.pagination__list a').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('column-grid', columnGridValue);
      link.href = url.toString();
    });
  }

  if (selectThreeButton) {
    selectThreeButton.addEventListener('click', () => {
      urlParams.set('column-grid', '3');
      setGridVars({ units: 6, standard: 2, dbl: 3, colsDesktop: 3 });
      window.history.replaceState({}, document.title, `${window.location.pathname}?${urlParams.toString()}`);
      replaceXlGridColumnClasses(6);
      replaceLgGridColumnClasses(6);
      toggleDesktopActiveClass(selectThreeButton);
      updatePaginationLinks('3');

      window?.processGridLayout && window.processGridLayout();
      window?.syncSpan4Heights && window.syncSpan4Heights();
    });
  }
  if (selectFourButton) {
    selectFourButton.addEventListener('click', () => {
      urlParams.set('column-grid', '4');
      setGridVars({ units: 8, standard: 2, dbl: 4, colsDesktop: 4 });
      window.history.replaceState({}, document.title, `${window.location.pathname}?${urlParams.toString()}`);
      replaceXlGridColumnClasses(8);
      replaceLgGridColumnClasses(8);
      toggleDesktopActiveClass(selectFourButton);
      updatePaginationLinks('4');
    });
  }
  if (selectOneButton) {
    selectOneButton.addEventListener('click', () => {
      urlParams.set('column-grid', '1');
      window.history.replaceState({}, document.title, `${window.location.pathname}?${urlParams.toString()}`);
      setGridVars({ units: 1, standard: 1, dbl: 1, colsMobile: 1 });
      replaceMaxMdGridColumnClasses(1);
      toggleMobileActiveClass(selectOneButton);
      updatePaginationLinks('1');
    });
  }
  if (selectTwoButton) {
    selectTwoButton.addEventListener('click', () => {
      urlParams.set('column-grid', '2');
      window.history.replaceState({}, document.title, `${window.location.pathname}?${urlParams.toString()}`);
      setGridVars({ units: 2, standard: 1, dbl: 2, colsMobile: 2 });
      replaceMaxMdGridColumnClasses(2);
      toggleMobileActiveClass(selectTwoButton);
      updatePaginationLinks('2');
    });
  }

  const MOBILE_BREAKPOINT = 990;
  function isDesktop() {
    return window.innerWidth >= MOBILE_BREAKPOINT;
  }
  let wasDesktop = isDesktop();
  function applyGridForBreakpoint() {
    const columnGridValue = urlParams.get('column-grid');

    if (isDesktop()) {
      // Desktop: only 3 or 4 column settings apply
      if (columnGridValue === '4') {
        setGridVars({ units: 8, standard: 2, dbl: 4, colsDesktop: 4 });
        replaceXlGridColumnClasses(8);
        replaceLgGridColumnClasses(8);
      } else if (columnGridValue === '3') {
        setGridVars({ units: 6, standard: 2, dbl: 3, colsDesktop: 3 });
        replaceXlGridColumnClasses(6);
        replaceLgGridColumnClasses(6);
      }
    } else {
      // Mobile: only 1 or 2 column settings apply
      if (columnGridValue === '2') {
        setGridVars({ units: 2, standard: 1, dbl: 2, colsMobile: 2 });
        replaceMaxMdGridColumnClasses(2);
      } else if (columnGridValue === '1') {
        setGridVars({ units: 1, standard: 1, dbl: 1, colsMobile: 1 });
        replaceMaxMdGridColumnClasses(1);
      }
    }
  }

  // Listen for breakpoint crossing
  window.addEventListener('resize', () => {
    const nowDesktop = isDesktop();
    if (nowDesktop !== wasDesktop) {
      wasDesktop = nowDesktop;
      applyGridForBreakpoint();

      window?.processGridLayout && window.processGridLayout();
      window?.syncSpan4Heights && window.syncSpan4Heights();
    }
  });

  // Replace the existing if (urlParams.has('column-grid')) block with:
  applyGridForBreakpoint();

  // Also update button active states based on current breakpoint
  if (urlParams.has('column-grid')) {
    const columnGridValue = urlParams.get('column-grid');
    if (columnGridValue === '1' && selectOneButton) toggleMobileActiveClass(selectOneButton);
    if (columnGridValue === '2' && selectTwoButton) toggleMobileActiveClass(selectTwoButton);
    if (columnGridValue === '3' && selectThreeButton) toggleDesktopActiveClass(selectThreeButton);
    if (columnGridValue === '4' && selectFourButton) toggleDesktopActiveClass(selectFourButton);
    updatePaginationLinks(columnGridValue);
  }
});
